<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <div class="f16">{{$t('auto_send')}}</div>
            <div class="table-box mg-top5">
                <Row class="table-tr th">
                    <Col class="table-td" span="4"></Col>
                    <Col class="table-td" span="4">{{$t('msg_mod_id')}}</Col>
                    <Col class="table-td" span="4">{{$t('msg_sign')}}</Col>
                    <Col class="table-td" span="8">{{$t('mod_content')}}</Col>
                    <Col class="table-td" span="2">{{$t('param_qty')}}</Col>
                    <Col class="table-td" span="2">{{$t('start_use')}}</Col>
                </Row>
                <Row class="table-tr" v-for="(item, index) in mod_type_auto" :key="index" v-if="org_level == '2' || (org_level != '2' && item.key != 'C')">
                    <Col class="table-td tright pd-top10" span="4">{{item.value}}</Col>
                    <Col class="table-td" span="4"><Input v-model="formData.mod_type_auto[index].msg_mod_id" disabled></Input></Col>
                    <Col class="table-td" span="4"><Input v-model="formData.mod_type_auto[index].msg_sign" disabled></Input></Col>
                    <Col class="table-td" span="8"><Input v-model="formData.mod_type_auto[index].mod_content" :rows="3" type="textarea" disabled></Input></Col>
                    <Col class="table-td" span="2"><Input v-model="formData.mod_type_auto[index].param_qty" disabled></Input></Col>
                    <Col class="table-td pd-top10" span="2"><Checkbox true-value='1' false-value='0' v-model="formData.mod_type_auto[index].mod_status" disabled></Checkbox></Col>
                </Row>
            </div>
            <div class="f16 mg-top15">{{$t('hand_send')}}</div>
            <div class="table-box mg-top5">
                <Row class="table-tr th">
                    <Col class="table-td" span="4"></Col>
                    <Col class="table-td" span="4">{{$t('msg_mod_id')}}</Col>
                    <Col class="table-td" span="4">{{$t('msg_sign')}}</Col>
                    <Col class="table-td" span="8">{{$t('mod_content')}}</Col>
                    <Col class="table-td" span="2">{{$t('param_qty')}}</Col>
                    <Col class="table-td" span="2">{{$t('start_use')}}</Col>
                </Row>
                <Row class="table-tr" v-for="(item, index) in mod_type_hand" :key="index">
                    <Col class="table-td tright pd-top10" span="4">{{item.value}}</Col>
                    <Col class="table-td" span="4"><Input v-model="formData.mod_type_hand[index].msg_mod_id" disabled></Input></Col>
                    <Col class="table-td" span="4"><Input v-model="formData.mod_type_hand[index].msg_sign" disabled></Input></Col>
                    <Col class="table-td" span="8"><Input v-model="formData.mod_type_hand[index].mod_content" :rows="3" type="textarea" disabled></Input></Col>
                    <Col class="table-td" span="2"><Input v-model="formData.mod_type_hand[index].param_qty" disabled></Input></Col>
                    <Col class="table-td pd-top10" span="2"><Checkbox true-value='1' false-value='0' v-model="formData.mod_type_hand[index].mod_status" disabled></Checkbox></Col>
                </Row>
            </div>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    import myUploadCompressedPic from '../../../components/myUploadCompressedPic'
    import myCropImg from '../../../components/myCropImg'
    export default {
        components:{
            myUploadCompressedPic,
            myCropImg
        },
        data:function(){
            return{
                relist:false,
                formData: {
                    org_id: "",
                    mod_type_auto: [],
                    mod_type_hand: []
                },
                org_level: '',
                mod_type_auto: [],
                mod_type_hand: []
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.org_id = this.$base.getRequest().org_id;
            this.org_level = this.$base.getRequest().org_level;
            this.getLoad();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getLoad: function(){
                var data = {
                    org_id: this.formData.org_id
                };
                this.$base.showLoading();
                this.$request.sendPost("org-down-s1/before-msg-mod-setup",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData.mod_type_auto = []
                        this.formData.mod_type_hand = []
                        for (let i = 0; i < data.mod_type_auto.length; i++) {
                            const params = {
                                msg_mod_id: data.mod_type_auto[i].msg_mod_id || '',
                                msg_sign: data.mod_type_auto[i].msg_sign || '',
                                mod_type: data.mod_type_auto[i].key,
                                mod_status: data.mod_type_auto[i].mod_status || '0',
                                mod_content: data.mod_type_auto[i].mod_content || '',
                                param_qty: data.mod_type_auto[i].param_qty || ''
                            }
                            this.formData.mod_type_auto.push(params)
                        }
                        this.mod_type_auto = this.mod_type_auto.concat(data.mod_type_auto);

                        for (let i = 0; i < data.mod_type_hand.length; i++) {
                            const params = {
                                msg_mod_id: data.mod_type_hand[i].msg_mod_id || '',
                                msg_sign: data.mod_type_hand[i].msg_sign || '',
                                mod_type: data.mod_type_hand[i].key,
                                mod_status: data.mod_type_hand[i].mod_status || '0',
                                mod_content: data.mod_type_hand[i].mod_content || '',
                                param_qty: data.mod_type_hand[i].param_qty || ''
                            }
                            this.formData.mod_type_hand.push(params)
                        }
                        this.mod_type_hand = this.mod_type_hand.concat(data.mod_type_hand);
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                console.log('this.formData', this.formData)
                this.$base.showLoading();
                this.$request.sendPost('org-down-s1/msg-mod-setup',this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.msgSuccess(error.errmsg);
                        this.relist = true;
                        this.$base.linkBack();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/down/downs1_msg.vue